var BootstrapParameters = function () {
    var parameters = [];
    this.setParameters = function (params) {
        parameters = params;
    };
    this.$get = function () {
        function getParameter(parameterName) {
            var filtered = parameters.filter(function (el) {
                return el.param.toLowerCase() == parameterName.toLowerCase();
            });
            if (filtered.length) {
                return filtered[0].value;
            } else {
                return undefined;
            }
        }
        return {
            getParameter: getParameter
        };
    };
};

module.exports = BootstrapParameters;